<template>
  <transition name="fade" v-if="value">
    <div id="mask" @click.capture="closeLayer2($event)">
      <div class="center-content">
        <i class="el-icon-close close" @click="closeLayer"></i>
        <slot></slot>
      </div>
    </div>
  </transition>
</template>
<script>
export default {
  name: 'MaskLayer',
  props: {
    value: {
      type: Boolean,
      default: true
    }
  },
  methods: {
    closeLayer () {
      this.$emit('input', false)
    },
    closeLayer2 (e) {
      if (e.target === this.$el) {
        this.$emit('input', false)
      }
    }
  }
}
</script>
<style lang="less">
.fade-enter-active, .fade-leave-active {
  transition: opacity .1s,transform .1s;
}
.fade-enter, .fade-leave-to {
  opacity: 0;
  transform: scale(0.7,0.7)
}
#mask {
  position: fixed;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  background-color: rgba(0, 0, 0, 0.5);
  display: flex;
  z-index: 2100;

  .center-content {
    min-width: 600px;
    margin: 100px auto;
    position: relative;
    overflow-y: auto;

    &>div {
      background-color: #ffffff;
      padding: 20px;
      z-index: -1;
    }

    .close {
      position: absolute;
      right: 5px;
      top: 5px;
      font-size: 25px;
      cursor: pointer;
      color: #F56C6C;
    }
  }
}
</style>



// WEBPACK FOOTER //
// src/components/MaskLayer/index.vue